export default {
    connectedSikayetvarAccounts(state) {
        return state.connectedSikayetvarAccounts;
    }
}